import { useEffect } from 'react';
import { usePrevious } from 'react-use';

export function useOnModalOpen(isOpen: boolean, onOpen: () => void) {
  const wasOpen = usePrevious(isOpen);

  useEffect(() => {
    if (isOpen && !wasOpen) {
      onOpen();
    }
  }, [isOpen, wasOpen, onOpen]);
}
